import { http } from '@/http/axios.js'


export function listAPI(data) {
  return http({
    url: '/api/manage/agent/list',
    method: 'POST',
    data
  })
}


export function listAgentAPI(data) {
  return http({
    url: '/api/manage/agent/employee/list',
    method: 'POST',
    data
  })
}

export function addAPI(data) {
  return http({
    url: '/api/manage/agent/add',
    method: 'POST',
    data
  })
}


export function editAPI(data) {
  return http({
    url: '/api/manage/agent/edit',
    method: 'POST',
    data
  })
}


export function delAPI(data) {
  return http({
    url: '/api/manage/agent/del',
    method: 'POST',
    data
  })
}



export function detailAPI(data) {
  return http({
    url: '/api/manage/agent/detail',
    method: 'POST',
    data
  })
}



